import * as React from "react";
import * as Moment from 'moment';
import Modal from "../misc/components/modal";
import { AuditModalBody } from "../auditmodal/components/AuditModalBody";
import { RandomizationForm, RandomizationModalBody } from "./RandomizationModalBody";
import LoadingWithMessage from "../misc/components/LoadingWithMessage";
import Alert, { AlertCategoryEnum } from "../misc/components/Alert";
import { useWebPortalApiClient } from "../misc/api/WebPortalTokenClient";
import { Subject } from "webportalclient";
import { useCurrentStudyConfigurationContext } from "../Core/CurrentStudyConfigurationContext";

interface ToggleRandomizationModalProps {
    subjectId: string;
    onClose: () => void;
}

export const ToggleRandomizationModal = ({ subjectId, onClose }: ToggleRandomizationModalProps) => {
    const [submitting, setSubmitting] = React.useState(false);
    const [confirmed, setConfirmed] = React.useState(false);
    const [subject, setSubject] = React.useState<Subject>();
    const [randomizationFormData, setRandomizationFormData] = React.useState<RandomizationForm>();
    const [errorAlert, setErrorAlert] = React.useState<string>(null);
    const { fieldDisplayText } = useCurrentStudyConfigurationContext();

    const Client = useWebPortalApiClient();

    React.useEffect(() => {
        const getData = async () => {
            const subject = await Client.client.getSubject(subjectId, "id,number,randomized,isRandomized,randomizationNumber", "site($select=studyId)");
            const currentDateString = Moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
            if (subject.isRandomized) {
                
                subject.randomized = Moment(new Date(subject.randomized)).format("YYYY-MM-DD HH:mm:ss");

            } else {
                subject.randomized = currentDateString;
            }
            setSubject(subject);
            setRandomizationFormData({
                SubjectNumber: subject.number,
                IsRandomized: subject.isRandomized,
                RandomizationNumber: subject.randomizationNumber,
                RandomizationDate: subject.randomized,
            } as RandomizationForm);
        }

        getData();
    }, []);

    const onHandleRandomizationModalSubmit = async (form: RandomizationForm) => {
        // Check if there is changes being made
        if (JSON.stringify(form) === JSON.stringify(randomizationFormData)) {
            onClose();
            return;
        }

        setRandomizationFormData({
            SubjectNumber: form.SubjectNumber,
            IsRandomized: form.IsRandomized,
            RandomizationNumber: form.RandomizationNumber,
            RandomizationDate: form.RandomizationDate
        } as RandomizationForm);

        setConfirmed(true); //to bring out the audit modal body
    }

    const onHandleModalSubmit = async (data: RandomizationForm) => {
        setSubmitting(true);
        setErrorAlert(null);

        try {
            await Client.client.patchSubjects({
                randomizationNumber: data.IsRandomized ? data.RandomizationNumber : null,
                randomized: data.IsRandomized ? data.RandomizationDate : null
            }, subjectId, "");
            onClose();
        } catch (ex) {
            setErrorAlert(ex.message);
        }


        setSubmitting(false);
        
    }

    return (
        
        <Modal show={true} header={`Update ${fieldDisplayText.SubjectTerminology} Randomization`} automationId="Modal">
            <Alert show={errorAlert !== null} category={AlertCategoryEnum.Danger}>
                {errorAlert}
            </Alert>
            {
                !randomizationFormData ? <LoadingWithMessage message="Loading Participant..." />
                    :
                confirmed ?
                    <AuditModalBody isAuditAnnotationDisabled={false} isSubmitting={submitting} onSubmit={() => onHandleModalSubmit(randomizationFormData)} onClose={onClose} annotationLabel="Update Randomization Reason" submitLabel="Update Randomization" />
                    :
                    <RandomizationModalBody studyId={subject.site.studyId} subjectId={subject.id} initialValues={randomizationFormData} onClose={onClose} onSubmit={(form) => { onHandleRandomizationModalSubmit(form) }} />
            }
        </Modal>
    );
}
